import {useEffect} from "react";
import useAppContext from "lib/hooks/use-app-context";

export default function Auth() {
  const {user} = useAppContext();

  useEffect(() => {
    if(!user) { return; }

    window.location.href = "/admin";
  }, [user]);

  return (
    <div className="container">
      <div className="max-w-screen-lg mx-auto text-center">
        <h1>Auth</h1>
        <p className="my-3">For admin use only</p>
        <a className="btn btn-blue" data-method="post" href="/auth/google">Google</a>
      </div>
    </div>
  );
}
